<template>
    <div>

        <!-- Default layout -->
        <a-layout class="layout-default" id="layout-default">

            <!-- Header -->
            <full-page-header></full-page-header>
            <!-- / Header -->


            <!-- Page Content -->
            <a-layout-content>
                <router-view/>
            </a-layout-content>
            <!-- / Page Content -->

            <!-- Footer -->
            <full-page-footer></full-page-footer>
            <!-- / Footer -->

        </a-layout>

    </div>
</template>

<script>
import FullPageHeader from './components/FullPageHeader.vue'
import FullPageFooter from './components/FullPageFooter.vue'
export default {
    components : {
        FullPageHeader,
        FullPageFooter
    }
}
</script>